import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import { Link } from 'react-router-dom';
import { getYear } from 'date-fns';

const FooterLayout: React.FC = ({ children }) => {
  return (<>  { /* <div style={{ zIndex: -1 }}>
    <Particles
      params={{
        particles: {
          lineLinked: {
            enable: false,
            distance: 250
          },
          move: {
            speed: 15,
            direction: 'top-right',
            collisions: false,
            outModes: {
              default: 'out',
              left: 'out',
              right: 'out',
              bottom: 'out',
              top: 'out',
            },


          },
          opacity: {
            value: 0.4,
            random: false,
            animation: {
              enable: false
            }

          },
          shape: {
            type: 'circle',
            polygon: {

              nb_sides: 6,

            },

          },

          color: { value: 'rgb(171, 230, 255)' },

          number: {
            density: {
              enable: true,
              value_area: 2400,
            },
            value: 60,
          },
          size: {
            value: 2,
            random: true,
          },
        },
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 1
      }}
    />
    </div> */}
    <div style={{ padding: '20px', background: '#333', width: '100%', paddingBottom: '50px', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>

      <div className='row-to-column ' style={{ gap: '30px', padding: '20px', background: '#333', width: '100%', maxWidth: '1200px', paddingBottom: '50px', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>


        <img src='/apoio/logo-branca.png' style={{ width: '200px', minWidth: '200px' }} />

        <div className='column-start gap-xs'>
          <strong style={{ padding: '5px' }}>POLÍTICAS</strong>
          <Link onClick={() => window?.scrollTo(0, 0)} className="scaleOnHover" to="/politica-de-imagem-e-privacidade" style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', padding: '5px' }}><p style={{ color: '#fff', fontSize: '16px', borderRadius: '5px', padding: '5px' }}>Política de Imagem e privacidade</p></Link>

          <Link onClick={() => window?.scrollTo(0, 0)} className="scaleOnHover" to="/politica-cancelamento" style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', padding: '5px' }}><p style={{ color: '#fff', fontSize: '16px', borderRadius: '5px', padding: '5px' }}>Política de cancelamento e reembolso</p></Link>
          <Link onClick={() => window?.scrollTo(0, 0)} className="scaleOnHover" to="/politica-cancelamento-cursos-aha" style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', padding: '5px' }}><p style={{ color: '#fff', fontSize: '16px', borderRadius: '5px', padding: '5px' }}>Política de cancelamento e reembolso <br /> dos Cursos AHA (BLC, ACLS e PALS)</p></Link>
        </div>
      </div>

    </div>

  </>
  );
};

export default FooterLayout;
